import { configureStore } from "@reduxjs/toolkit"

//import rootReducer from "../rootReducer"
import { save, load } from "../components/LocalStorageMiddleware"

import selectionReducer from "../containers/selectionSlice"
import appReducer from "../containers/applicationSlice"
import notificationReducer from "../containers/notificationSlice"
import transactionReducer from "../containers/transactionSlice"

const store = configureStore({
  reducer: {
    selectionReducer,
    appReducer,
    notificationReducer,
    transactionReducer
  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([save]),

  preloadedState: load()
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export default store // createStore(rootReducer)
